import { useEffect, useState } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import "./WhyUs.css";

const WhyUs = () => {
  const [heading, setHeading] = useState({
    title: "",
    intro: "",
  });

  const [whyFeatures, setWhyFeatures] = useState([]);
  const [integration, setIntegration] = useState({
    title: "",
    items: [],
  });

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();
      if (!data) return;

      setHeading({
        title:
          data?.why_teleforce_title?.value ||
          data?.why_teleforce_title ||
          "",
        intro:
          data?.why_teleforce_intro?.value ||
          data?.why_teleforce_intro ||
          "",
      });

      const whyList = [];
      for (let i = 1; i <= 6; i++) {
        const title =
          data?.[`why_feature_${i}_title`]?.value ||
          data?.[`why_feature_${i}_title`];

        const desc =
          data?.[`why_feature_${i}_desc`]?.value ||
          data?.[`why_feature_${i}_desc`];

        if (title && desc) {
          whyList.push({ title, desc });
        }
      }
      setWhyFeatures(whyList);

      const integrationItems = [];
      for (let i = 1; i <= 3; i++) {
        const title =
          data?.[`integration_${i}_title`]?.value ||
          data?.[`integration_${i}_title`];

        const desc =
          data?.[`integration_${i}_desc`]?.value ||
          data?.[`integration_${i}_desc`];

        if (title && desc) {
          integrationItems.push({ title, desc });
        }
      }

      setIntegration({
        title:
          data?.integrations_title?.value ||
          data?.integrations_title ||
          "",
        items: integrationItems,
      });
    };

    fetchSettings();
  }, []);

  return (
    <section className="py-5 bg-white" id="why">
      <div className="container mt-5">

        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">{heading.title}</h2>
          {heading.intro && (
            <p className="text-muted mx-auto" style={{ maxWidth: "760px" }}>
              {heading.intro}
            </p>
          )}
        </div>

        <div className="row g-4 justify-content-center">
          {whyFeatures.map((item, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="why-card h-100">
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        {integration.title && (
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-10">
              <div className="integration-box text-center">
                <h4 className="fw-semibold mb-3">
                  {integration.title}
                </h4>

                <div className="row g-4 mt-3">
                  {integration.items.map((item, index) => (
                    <div key={index} className="col-md-4">
                      <h6 className="fw-semibold">{item.title}</h6>
                      <p className="text-muted mb-0">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default WhyUs;
